var map = {
	"./base.json": 1000,
	"./de.campercontact.json": 1001,
	"./de.json": 1002,
	"./de.zandvoort.json": 1003,
	"./en.campercontact.json": 1004,
	"./en.json": 1005,
	"./en.zandvoort.json": 1006,
	"./nl.campercontact.json": 1007,
	"./nl.json": 1008,
	"./nl.zandvoort.json": 1009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 999;